import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { useEffect, useState } from "react";
import {
  fetchStateGovernmentDetails,
  formatNumber,
} from "../../../redux/thunk";
import axios from "axios";
import { IoAdd, IoSearchOutline } from "react-icons/io5";
import toast from "react-hot-toast";
import { FaRegCopy } from "react-icons/fa6";
import Pagination from "../../../components/Pagination";
import { AllBanksModal } from "../../../components/modals/AllBanksModal";
import UpdateCreditLimit from "../../../components/modals/UpdateCreditLimit";
import { AddBankModal } from "../../../components/modals/AddBankModal";
import BVNVerificationModal from "../../../components/modals/BVNVerificationModal";
import StateGovModal from "../../../components/modals/StateGovModal";

const AssignedMinistry = () => {
  const location = useLocation();
  const { state } = location;
  const [loading, setLoading] = useState(false);
  const [ministryId, setMinistryId] = useState("");
  const [ministryUsers, setMinistryUsers] = useState([]);
  const [searchedUser, setSearchedUser] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [itemsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedBvn, setSelectedBvn] = useState("");
  const [bvnModalOpen, setBvnModalOpen] = useState(false);
  const [addBankModal, setAddBankModal] = useState(false);
  const [userToAddBank, setUserToAddBank] = useState({
    name: "",
    id: "",
  });
  const [employmentDetails, setEmploymentDetails] = useState(null);
  const [showEmploymentDetails, setShowEmploymentDetails] = useState(false);
  const [userData, setUserData] = useState(null);
  const [viewUpdateCreditLimit, setViewUpdateCreditLimit] = useState(false);
  const [userId, setUserId] = useState("");
  const [allBanksDetails, setAllBanksDetails] = useState([]);
  const [allBanksModal, setAllBanksModal] = useState(false);
  const { token } = useAppSelector((state) => state.auth);
  const { stateGovs } = useAppSelector((state) => state.stateGovs as any);
  const dispatch = useAppDispatch();

  const indexOfLastPost = currentPage * itemsPerPage;
  const indexOfFirstPost = indexOfLastPost - itemsPerPage;
  const currentItems = Array.isArray(ministryUsers)
    ? ministryUsers.slice(indexOfFirstPost, indexOfLastPost)
    : [];

  const handlePagination = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const prevPage = () => {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const nextPage = () => {
    if (currentPage !== Math.ceil(ministryUsers.length / itemsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  useEffect(() => {
    dispatch(fetchStateGovernmentDetails());
  }, []);

  useEffect(() => {
    const ministry = stateGovs[0]?.ministries || [];
    setLoading(true);
    const selectedMinistry = ministry.find(
      (item: any) => item.name === state.ministry
    );
    if (selectedMinistry) {
      setMinistryId(selectedMinistry._id);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    const getUsersByMinistryId = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/getCustomersByStateGovAndMinistryId/${stateGovs[0].stateId}/${ministryId}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
        setMinistryUsers(res.data.customers);
      } catch (error) {
        console.error("Error fetching users by ministry ID:", error);
      }
    };
    if (ministryId) {
      getUsersByMinistryId();
    }
  }, [ministryId]);

  const searchForUsersWithEmail = (value: string) => {
    setSearchedUser(value);
    if (value.length > 0) {
      const searchResult =
        ministryUsers?.filter((user: any) =>
          user.email?.toLowerCase().includes(value.toLowerCase())
        ) || null;
      setSearchResults(searchResult);
    } else {
      setSearchResults([]);
    }
  };

  const handleCopyClick = async (text: any) => {
    if (!text) return;
    try {
      await navigator.clipboard.writeText(text);
      toast.success("Copied to clipboard!");
    } catch (err) {
      console.error("Failed to copy: ", err);
      toast.error("Failed to copy.");
    }
  };

  const handleBvnClick = (bvn: string) => {
    setSelectedBvn(bvn);
    setBvnModalOpen(true);
  };

  const handleEmploymentDetails = (data: any) => {
    setEmploymentDetails(data);
    setShowEmploymentDetails(true);
  };

  const handleUpdateCreditLimit = (data: any) => {
    setUserData(data);
    setViewUpdateCreditLimit((prev) => !prev);
  };

  const handleViewAllBank = (id: string, linkedBanks: any) => {
    setUserId(id);
    setAllBanksDetails(linkedBanks);
    setAllBanksModal((prev) => !prev);
  };

  const handleAddBank = (firstName: any, lastName: any, id: string) => {
    setUserToAddBank({ name: lastName + " " + firstName, id });
    setAddBankModal((prev) => !prev);
  };

  const mainData = searchedUser.length > 0 ? searchResults : currentItems;

  return (
    <section>
      <h1 className="font-bold text-xl">{state.ministry}</h1>

      <section className={`${loading && "animate-pulse"}`}>
        <div
          className="flex items-center justify-between p-6"
          style={{ minWidth: "700px" }}
        >
          <div className="flex justify-between w-full">
            <div className="relative md:w-[30rem] w-fit">
              <IoSearchOutline className="w-6 h-6 absolute top-[0.6rem] left-2 text-gray-300" />
              <input
                type="search"
                name="searchedUser"
                id="searchedUser"
                value={searchedUser}
                onChange={(e) => searchForUsersWithEmail(e.target.value)}
                placeholder="Search user using email"
                className="border p-2 text-sm rounded-md indent-7 w-full"
                disabled={ministryUsers.length === 0}
              />
            </div>
          </div>
        </div>
        <section className="overflow-x-auto">
          <table className="w-[1020px]" style={{ minWidth: "700px" }}>
            <thead className="bg-gray-50 font-bold p-4 text-left">
              <tr>
                <th className="p-2 ">S/N</th>
                <th className="p-2 text-nowrap">Name</th>
                <th className="p-2 text-nowrap">Email</th>
                <th className="p-2 text-nowrap">Phone Number</th>
                <th className="p-2">BVN</th>
                <th className="p-2 text-nowrap">Add Bank</th>
                <th className="p-2 text-nowrap">All Banks</th>
                <th className="p-2 text-nowrap">Employment</th>
                <th className="p-2 text-nowrap">Credit Score(Balance)</th>
                <th className="p-2 text-nowrap">Credit Score</th>
                <th className="p-2 text-nowrap">Open Password</th>
                <th className="p-2 text-nowrap">Action</th>
              </tr>
            </thead>
            <tbody className="px-4">
              {mainData.length > 0 ? (
                mainData.map((data: any, index: any) => (
                  <tr className="border-b border-gray-300 py-2" key={index}>
                    <td className="text-secondary p-2">
                      {index + indexOfFirstPost + 1}
                    </td>
                    <td className="p-2 text-nowrap">
                      {data.lastName} {data.firstName}
                    </td>
                    <td className="p-2">
                      <div className="flex justify-between gap-2 items-center">
                        <p>{data.email}</p>
                        <button
                          type="button"
                          className="mr-3"
                          onClick={() => handleCopyClick(data.email)}
                        >
                          <FaRegCopy className="w-5 h-5 text-gray-500" />
                        </button>
                      </div>
                    </td>
                    <td className="p-2 text-nowrap">{data.phoneNumber}</td>
                    <td className="p-2">
                      <div className="flex items-center gap-2 justify-between">
                        <button
                          onClick={() => handleBvnClick(data)}
                          className="text-blue-500 hover:underline focus:outline-none"
                        >
                          {data.bvn}
                        </button>
                        <button
                          type="button"
                          className=""
                          onClick={() => handleCopyClick(data.bvn)}
                        >
                          <FaRegCopy className="w-5 h-5 text-gray-500" />
                        </button>
                      </div>
                    </td>
                    <td className="p-2 text-center">
                      <button
                        className="text-secondary border"
                        onClick={() =>
                          handleAddBank(data.firstName, data.lastName, data._id)
                        }
                      >
                        <IoAdd className="w-9 h-9" />
                      </button>
                    </td>

                    <td className="p-2 text-center">
                      <button
                        className="bg-secondary text-white text-sm rounded-md p-2"
                        onClick={() =>
                          handleViewAllBank(data._id, data.linkedBanks)
                        }
                      >
                        View
                      </button>
                    </td>
                    <td className="p-2 text-nowrap">
                      <button
                        onClick={() =>
                          handleEmploymentDetails(data.stateGovernmentData)
                        }
                        className="text-secondary hover:underline focus:outline-none text-center"
                      >
                        View
                      </button>
                    </td>
                    <td className="p-2">
                      {data.creditScore
                        ? `₦${formatNumber(data.creditScore)}`
                        : "---"}
                    </td>
                    <td className="p-2">
                      {data.creditLimit
                        ? `₦${formatNumber(data.creditLimit)}`
                        : "---"}
                    </td>
                    <td className="p-2">
                      {data.userPassword ? data.userPassword : "not found"}
                    </td>
                    <td className="p-2 text-nowrap">
                      <button
                        type="button"
                        className="p-2 text-sm text-secondary border border-secondary"
                        onClick={() => handleUpdateCreditLimit(data)}
                      >
                        Update Credit Limit
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={10} className="text-center text-secondary p-3">
                    User not found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </section>
      </section>
      <section className="p-3 my-5">
        <Pagination
          length={
            searchResults.length > 0
              ? searchResults.length
              : ministryUsers?.length || 0
          }
          itemsPerPage={itemsPerPage}
          handlePagination={handlePagination}
          currentPage={currentPage}
          prevPage={prevPage}
          nextPage={nextPage}
        />
      </section>
      {allBanksModal && (
        <AllBanksModal
          setAllBanksModal={setAllBanksModal}
          setAllBanksDetails={setAllBanksDetails}
          allBanksDetails={allBanksDetails}
          setSearchedUser={setSearchedUser}
          userId={userId}
        />
      )}

      {viewUpdateCreditLimit && (
        <UpdateCreditLimit
          userData={userData}
          closeModal={() => setViewUpdateCreditLimit(false)}
        />
      )}

      {addBankModal && (
        <AddBankModal
          setAddBankModal={setAddBankModal}
          userToAddBank={userToAddBank}
        />
      )}

      {showEmploymentDetails && (
        <StateGovModal
          selectedInfo={employmentDetails}
          setStateGovModalOpen={setShowEmploymentDetails}
        />
      )}

      {bvnModalOpen && (
        <BVNVerificationModal
          setBvnModalOpen={setBvnModalOpen}
          selectedBvn={selectedBvn}
        />
      )}
    </section>
  );
};

export default AssignedMinistry;
